import React from "react";
import { MantineList, MantineListItem } from "../mantine/list";
import { hasCapitalLetter, hasMinimumLength, hasNoStartingNumber, hasNumber, hasSpecialCharacter } from "../../helpers/common";

const PasswordValidation = (props: any) => {
    const { ispasswordCondition, className } = props;

    return (
        <>
            <MantineList className={`-mt-2 ${className}`} listStyleType="disc" >
            <MantineListItem className={`text-sm ${hasNoStartingNumber(ispasswordCondition) ? 'text-emerald-500' : 'text-validation_normal_text_color'}`}>Don't start with Number</MantineListItem>
                <MantineListItem className={`text-sm ${hasMinimumLength(ispasswordCondition) ? 'text-emerald-500' : 'text-validation_normal_text_color'}`}>Minimum 8 characters</MantineListItem>
                <MantineListItem className={`text-sm ${hasNumber(ispasswordCondition) ? 'text-emerald-500' : 'text-validation_normal_text_color'}`}>Minimum One number</MantineListItem>
                <MantineListItem className={`text-sm ${hasSpecialCharacter(ispasswordCondition) ? 'text-emerald-500' : 'text-validation_normal_text_color'}`}>Include a special character</MantineListItem>
                <MantineListItem className={`text-sm ${hasCapitalLetter(ispasswordCondition) ? 'text-emerald-500' : 'text-validation_normal_text_color'}`}>Minimum one CAPITAL letter</MantineListItem>
            </MantineList>
        </>
    )
}
export default PasswordValidation;